import { createTheme, responsiveFontSizes } from "@mui/material/styles";
/**
 * Base application theme (MUI) with brand colors and typography
 */
let theme = createTheme({
  palette: {
    primary: {
      main: "#173760",
    },
    secondary: {
      main: "#707070",
      light: "#51B7FA",
      contrastText: "#fff",
    },
    background: {
      default: "#F9F9F9",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#333333",
      secondary: "#888888",
    },
  },
  typography: {
    h1: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
  },
  spacing: 8,
});
theme = responsiveFontSizes(theme);
export default theme;
